jQuery(document).ready(function () {
	window.dispatchEvent(new Event('resize'));
});
jQuery(document).ready(function() {
	jQuery(window).scroll(function() {
	var sticky = jQuery('#header-component'),
	scroll = jQuery(window).scrollTop();
	if (scroll >= 100) sticky.addClass('fixed');
	else sticky.removeClass('fixed');
	});
});

// ---------------------- // NEW PREMIUM ANIMATIONS // ---------------------- //
// document.addEventListener("DOMContentLoaded", function () {
//     ScrollReveal().reveal('.reveal , .shopify-policy__body  h1 , .shopify-policy__body  p  , .shopify-policy__body  ul li , .shopify-policy__body  h2 , .shopify-policy__body  h3 , .page-design h2 , .page-design p , .page-design ul li , .co-head , .page-design .img-grid , .template-article .layout-panel-flex.layout-panel-flex--column.section-content-wrapper h1 , .blog-post-content p , body .blog-post-details , .blog-posts-container .blog-post-item .blog-post-card , .row.grid-2.careers-row , .careers-item .panel.panel-default h3 ', {
//         delay: 200,
//         distance: '50px',
//         origin: 'bottom',   
//         duration: 1000,     
//         easing: 'ease-in-out',
//         interval: 100
//     });
//     ScrollReveal().reveal('.reveal-bottom-item , .product-information .product-information__grid', {
//         delay: 200,
//         distance: '50px',
//         origin: 'bottom',
//         duration: 1000,
//         easing: 'ease-in-out',
//         interval: 200
//     });
//     ScrollReveal().reveal('.fade-in-scroll , .resource-list.featured-products , .product-grid li , .template-list-collections .resource-list.resource-list--grid .resource-list__item ', {
//         delay: 20,
//         duration: 500,
//         distance: '0px',
//         opacity: 0,
//         scale: 0.97,
//         easing: 'ease-in-out',
//         interval: 80
//     });
//     ScrollReveal().reveal('.reveal-bottom , .product-recommendations .section-resource-list', {
//         origin: 'bottom',
//         distance: '50px',
//         duration: 1000
//     });
//     ScrollReveal().reveal('.reveal-right , .cc-header-row a', {
//         origin: 'right',
//         distance: '80px',
//         duration: 1300,
//         easing: 'ease-in-out'
//     });
//     ScrollReveal().reveal('.reveal-left , .cc-header-row h2 , .cc-header-row p', {
//         origin: 'left',
//         distance: '80px',
//         duration: 1300,
//         easing: 'ease-in-out'
//     });
//     ScrollReveal().reveal('.zoom-in , .facets.facets--horizontal , .jdgm-widget-row', {
//         duration: 1000,
//         scale: 0.85, 
//         opacity: 0,   
//         easing: 'ease-out',
//         reset: false
//     });
//     ScrollReveal().reveal('.rotate-in', {
//         rotate: { x: 0, y: 0, z: 45 },
//         duration: 1200,
//         opacity: 0,
//         distance: '0px',
//         easing: 'ease-in-out'
//     });
//     ScrollReveal().reveal('.flip-up', {
//         rotate: { x: -90, y: 0, z: 0 },
//         duration: 1200,
//         opacity: 0,
//         easing: 'ease-out',
//     });
//     ScrollReveal().reveal('.blur-in', {
//         opacity: 0,
//         duration: 1200,
//         scale: 0.9,
//         easing: 'ease',
//         beforeReveal: function(el) {
//             el.style.filter = "blur(8px)";
//         },
//         afterReveal: function(el) {
//             el.style.filter = "blur(0px)";
//         }
//     });
//     ScrollReveal().reveal('.skew-in', {
//         opacity: 0,
//         duration: 1200,
//         easing: 'ease-out',
//         beforeReveal(el) {
//             el.style.transform = "skewY(8deg)";
//         },
//         afterReveal(el) {
//             el.style.transform = "skewY(0deg)";
//         }
//     });
//     ScrollReveal().reveal('.lift-shadow', {
//         distance: '20px',
//         origin: 'bottom',
//         duration: 900,
//         opacity: 0,
//         beforeReveal(el) {
//             el.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
//         },
//         afterReveal(el) {
//             el.style.boxShadow = "0 0 0 rgba(0,0,0,0)";
//         }
//     });
//     ScrollReveal().reveal('.random-fade , .product-tabs', {
//         duration: 1000,
//         distance: '30px',
//         opacity: 0,
//         origin: ['left','right','bottom'][Math.floor(Math.random()*3)],
//         interval: 200
//     });
//     ScrollReveal().reveal('.zoom-out , .blog-post-featured-image__image', {
//         scale: 1.2,
//         opacity: 0,
//         duration: 1100,
//         easing: 'ease-out'
//     });
//     ScrollReveal().reveal('.slide-rotate', {
//         distance: '60px',
//         origin: 'bottom',
//         rotate: { x: 0, y: 0, z: -10 },
//         opacity: 0,
//         duration: 1300,
//         easing: 'ease-in-out'
//     });
// });

// $(document).ready(function () {
//   $('.featured-products').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     dots: true,
//     arrows: false,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 9000,
//     speed: 900,             
//     cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
//     useTransform: true,
//     easing: 'ease',
//     touchThreshold: 10,        
//     waitForAnimate: true,
//     pauseOnHover: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 2
//         }
//       }
//     ]
//   });
// });

// jQuery(function ($) {
//   function initRecommendationsSlider() {
//     var $slider = $('.product-recommendations .resource-list--grid');
//     if (!$slider.length) return;
//     if ($slider.hasClass('slick-initialized')) return;
//     $slider
//       .on('init', function () {
//         $slider.css('display', 'block');
//       })
//       .slick({
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         arrows: false,
//         dots: true,
//         autoplay: true,
//         autoplaySpeed: 7000,
//         speed: 600,
//         infinite: true,
//         lazyLoad: 'ondemand',
//         responsive: [
//           { breakpoint: 1191, settings: { slidesToShow: 3 } },
//           { breakpoint: 800, settings: { slidesToShow: 3 } },
//           { breakpoint: 769, settings: { slidesToShow: 2 } },
//           { breakpoint: 500, settings: { slidesToShow: 2, adaptiveHeight: true } }
//         ]
//       });
//   }
//   initRecommendationsSlider();
//   document.addEventListener('shopify:section:load', function (event) {
//     if (event.target.querySelector('.product-recommendations')) {
//       initRecommendationsSlider();
//     }
//   });
//   const observer = new MutationObserver(function () {
//     initRecommendationsSlider();
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });

jQuery(function ($) {

    // ===== CONFIG OPTIONS =====
    var swiperOptions = {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        autoplay: true,       // true = autoplay on, false = off
        autoplayDelay: 7000,  // delay in ms
        dots: true,           // true = pagination dots visible
        arrows: false          // true = navigation arrows visible
    };

    var swiperInstance = null;

    function initRecommendationsSwiper() {

        var container = document.querySelector(
            '.product-recommendations .resource-list--grid'
        );

        if (!container) return;

        // Prevent double init
        if (container.classList.contains('swiper-initialized')) return;

        container.classList.add('swiper');

        // Wrap children if wrapper not exists
        if (!container.querySelector('.swiper-wrapper')) {

            var wrapper = document.createElement('div');
            wrapper.classList.add('swiper-wrapper');

            Array.from(container.children).forEach(function (child) {
                child.classList.add('swiper-slide');
                wrapper.appendChild(child);
            });

            container.innerHTML = '';
            container.appendChild(wrapper);
        }

        // Destroy old instance if exists
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
        }

        // Prepare Swiper config
        var config = {
            slidesPerView: swiperOptions.slidesPerView,
            spaceBetween: swiperOptions.spaceBetween,
            loop: swiperOptions.loop,
            speed: 600,
            autoplay: swiperOptions.autoplay ? { delay: swiperOptions.autoplayDelay, disableOnInteraction: false } : false,
            breakpoints: {
                0: { slidesPerView: 1 },
                500: { slidesPerView: 2 },
                769: { slidesPerView: 2 },
                800: { slidesPerView: 3 },
                1191: { slidesPerView: 3 },
                1200: { slidesPerView: swiperOptions.slidesPerView }
            }
        };

        // ===== Pagination Dots =====
        if (swiperOptions.dots) {
            var pagination = document.createElement('div');
            pagination.classList.add('swiper-pagination');
            container.appendChild(pagination);
            config.pagination = {
                el: pagination,
                clickable: true
            };
        }

        // ===== Navigation Arrows =====
        if (swiperOptions.arrows) {
            var nextBtn = document.createElement('div');
            nextBtn.classList.add('swiper-button-next');

            var prevBtn = document.createElement('div');
            prevBtn.classList.add('swiper-button-prev');

            container.appendChild(nextBtn);
            container.appendChild(prevBtn);

            config.navigation = {
                nextEl: nextBtn,
                prevEl: prevBtn
            };
        }

        // ===== Initialize Swiper =====
        swiperInstance = new Swiper(container, config);
    }

    // ===== Initial Load =====
    initRecommendationsSwiper();

    // ===== Shopify Section Reload =====
    document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('.product-recommendations')) {
            initRecommendationsSwiper();
        }
    });

    // ===== Mutation Observer Fallback =====
    var observer = new MutationObserver(function () {
        initRecommendationsSwiper();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".video-box iframe").forEach(function (iframe) {
    iframe.src = iframe.dataset.src;

    iframe.addEventListener("load", function () {
      iframe.closest(".video-box").classList.add("loaded");
    });
  });
});

$(document).ready(function () {
  if ($('.hero-banner-image-row').length > 0) {
    $('body').addClass('available-banner');
  }
});

(function () {
  function updateHeaderClass() {
    const header = document.querySelector('.header');
    if (!header) return;
    const isOpen = document.querySelector(
      '.menu-list__list-item.has-submenu [aria-expanded="true"]'
    );
    header.classList.toggle('open-max-mega-menu', !!isOpen);
  }
  function bindMenuEvents() {
    const items = document.querySelectorAll('.menu-list__list-item.has-submenu');
    if (!items.length) return false;
    items.forEach(item => {
      item.addEventListener('mouseenter', updateHeaderClass);
      item.addEventListener('mouseleave', updateHeaderClass);
      const link = item.querySelector('a');
      if (link) {
        link.addEventListener('click', () => {
          setTimeout(updateHeaderClass, 50);
        });
      }
      item.querySelectorAll('[aria-expanded]').forEach(el => {
        observer.observe(el, {
          attributes: true,
          attributeFilter: ['aria-expanded']
        });
      });
    });

    updateHeaderClass();
    return true;
  }
  const observer = new MutationObserver(updateHeaderClass);
  let tries = 0;
  const retry = setInterval(() => {
    tries++;
    if (bindMenuEvents() || tries > 20) {
      clearInterval(retry);
    }
  }, 200);
  document.addEventListener('DOMContentLoaded', updateHeaderClass);
  document.addEventListener('shopify:section:load', updateHeaderClass);
})();

$(document).ready(function () {
  let sliderActive = false;
  let loaderUsedOnce = false;
  let swiperInstance = null;

  const $slider = $('.usp-container-slider');
  const $loader = $('.hero-loader-overlay');
  const $uspSection = $('.usp-section');

  function setUSPHeight(height) {
    $uspSection.each(function () {
      this.style.setProperty('height', height, 'important');
    });
  }

  function initSwiper() {
    if (swiperInstance) return;

    // add swiper classes dynamically
    $slider.addClass('swiper');
    const $items = $slider.children();

    // wrapper create
    if (!$slider.find('.swiper-wrapper').length) {
      $items.wrapAll('<div class="swiper-wrapper"></div>');
      $items.addClass('swiper-slide');
    }

    swiperInstance = new Swiper('.usp-container-slider.swiper', {
      slidesPerView: 3,
      spaceBetween: 0,
      speed: 900,
      allowTouchMove: true,
      breakpoints: {
        0: { slidesPerView: 1 },
        400: { slidesPerView: 2 },
        768: { slidesPerView: 3 }
      }
    });

    sliderActive = true;
    loaderUsedOnce = true;

    setUSPHeight('auto');

    setTimeout(() => {
      $loader.addClass('is-hidden');
    }, 200);
  }

  function destroySwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;

      // remove classes to restore layout
      $slider.removeClass('swiper');
      $slider.find('.swiper-slide').removeClass('swiper-slide');

      const $wrapper = $slider.find('.swiper-wrapper');
      if ($wrapper.length) {
        $wrapper.children().unwrap();
      }

      sliderActive = false;
    }
  }

  function toggleFeaturedSlider() {
    const winWidth = window.innerWidth;

    if (winWidth < 994) {
      if (!sliderActive) {
        setUSPHeight('125px');
      }

      if (!sliderActive && !loaderUsedOnce) {
        $loader.removeClass('is-hidden');
      }

      initSwiper();
    } else {
      destroySwiper();
      setUSPHeight('auto');
      $loader.addClass('is-hidden');
    }
  }

  toggleFeaturedSlider();

  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(toggleFeaturedSlider, 200);
  });
});


// $(document).ready(function () {
//   let sliderActive = false;
//   let loaderUsedOnce = false;
//   const $slider = $('.usp-container-slider');
//   const $loader = $('.hero-loader-overlay');
//   const $uspSection = $('.usp-section');
//   function setUSPHeight(height) {
//     $uspSection.each(function () {
//       this.style.setProperty('height', height, 'important');
//     });
//   }
//   function toggleFeaturedSlider() {
//     const winWidth = window.innerWidth;
//     if (winWidth < 994) {
//       if (!sliderActive) {
//         setUSPHeight('125px');
//       }
//       if (!sliderActive && !loaderUsedOnce) {
//         $loader.removeClass('is-hidden');
//       }
//       if (!sliderActive) {
//         $slider
//           .one('init', function () {
//             sliderActive = true;
//             loaderUsedOnce = true;
//             setUSPHeight('auto');
//             setTimeout(() => {
//               $loader.addClass('is-hidden');
//             }, 200);
//           })
//           .slick({
//             slidesToShow: 3,
//             slidesToScroll: 1,
//             arrows: false,
//             dots: false,
//             infinite: false,
//             speed: 900,
//             cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
//             touchThreshold: 10,
//             initialSlide: 0,
//             responsive: [
//               {
//                 breakpoint: 768,
//                 settings: { slidesToShow: 2 }
//               },
//               {
//                 breakpoint: 400,
//                 settings: { slidesToShow: 1 }
//               }
//             ]
//           });
//       }
//     } else {
//       if (sliderActive && $slider.hasClass('slick-initialized')) {
//         $slider.slick('unslick');
//         sliderActive = false;
//       }
//       setUSPHeight('auto');
//       $loader.addClass('is-hidden');
//     }
//   }
//   toggleFeaturedSlider();
//   let resizeTimer;
//   $(window).on('resize', function () {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(toggleFeaturedSlider, 200);
//   });
// });


$(document).ready(function () {
  let bespokeSliderActive = false;
  let bespokeSwiper = null;
  const $grid = $('.bespoke-grid');

  function initBespokeSwiper() {
    if (bespokeSwiper) return;

    // swiper class add
    $grid.addClass('swiper');

    const $cards = $grid.children();

    // wrapper create dynamically
    if (!$grid.find('.swiper-wrapper').length) {
      $cards.wrapAll('<div class="swiper-wrapper"></div>');
      $cards.addClass('swiper-slide');
    }

    bespokeSwiper = new Swiper('.bespoke-grid.swiper', {
      slidesPerView: 2,
      spaceBetween: 20,
      speed: 700,
      allowTouchMove: true,
      autoHeight: true,

      pagination: {
        el: document.createElement('div'),
        clickable: true
      },

      breakpoints: {
        0: { slidesPerView: 1 },
        551: { slidesPerView: 2 }
      }
    });

    // dots container add (since HTML change allowed nahi)
    if (!$grid.find('.swiper-pagination').length) {
      const paginationEl = $('<div class="swiper-pagination"></div>');
      $grid.append(paginationEl);
      bespokeSwiper.params.pagination.el = paginationEl[0];
      bespokeSwiper.pagination.init();
      bespokeSwiper.pagination.render();
      bespokeSwiper.pagination.update();
    }

    bespokeSliderActive = true;
  }

  function destroyBespokeSwiper() {
    if (bespokeSwiper) {
      bespokeSwiper.destroy(true, true);
      bespokeSwiper = null;

      // restore original layout
      $grid.removeClass('swiper');
      $grid.find('.swiper-slide').removeClass('swiper-slide');

      const $wrapper = $grid.find('.swiper-wrapper');
      if ($wrapper.length) {
        $wrapper.children().unwrap();
      }

      $grid.find('.swiper-pagination').remove();

      bespokeSliderActive = false;
    }
  }

  function toggleBespokeSlider() {
    const winWidth = window.innerWidth;

    if (winWidth < 770) {
      initBespokeSwiper();
    } else {
      destroyBespokeSwiper();
    }
  }

  toggleBespokeSlider();

  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(toggleBespokeSlider, 200);
  });
});


// $(document).ready(function () {
//   let bespokeSliderActive = false;
//   function toggleBespokeSlider() {
//     const winWidth = window.innerWidth;
//     if (winWidth < 770) {
//       if (!bespokeSliderActive) {
//         $('.bespoke-grid')
//           .on('init', function () {
//             bespokeSliderActive = true;
//           })
//           .slick({
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             dots: true,
//             arrows: false,
//             infinite: false,
//             speed: 700,
//             cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
//             touchThreshold: 10,
//             adaptiveHeight: true,
//             responsive: [
//               {
//                 breakpoint: 551,
//                 settings: {
//                   slidesToShow: 1
//                 }
//               }
//             ]
//           });
//       }
//     } else {
//       if (bespokeSliderActive && $('.bespoke-grid').hasClass('slick-initialized')) {
//         $('.bespoke-grid').slick('unslick');
//         bespokeSliderActive = false;
//       }
//     }
//   }
//   toggleBespokeSlider();
//   let resizeTimer;
//   $(window).on('resize', function () {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(toggleBespokeSlider, 200);
//   });
// });

jQuery(document).ready(function ($) {
  $('.cookie-policy-page').each(function () {
    if ($.trim($(this).html()) === '') {
      $(this).hide();
    }
  });
});


$(document).ready(function () {
  $('.careers-row .panel-heading').on('click', function () {
    const panel = $(this).closest('.panel');
    const content = panel.find('.oppo_rtun');
    panel
      .closest('.careers-row')
      .find('.panel')
      .not(panel)
      .removeClass('open')
      .find('.oppo_rtun')
      .slideUp(300);
    panel.toggleClass('open');
    content.stop(true, true).slideToggle(300);
  });
});



// document.addEventListener('DOMContentLoaded', function() {
//   const viewSpans = document.querySelectorAll('.blog-view-count');

//   viewSpans.forEach(span => {
//     const articleId = span.getAttribute('data-article-id');
//     const storageKey = 'blog_view_' + articleId;

//     // Get current count from localStorage
//     let currentCount = parseInt(localStorage.getItem(storageKey)) || 0;

//     // Increment count if first time
//     if (!currentCount) {
//       currentCount = 1;
//       localStorage.setItem(storageKey, currentCount);
//     }

//     // Update the displayed count
//     span.querySelector('.viewCount').textContent = currentCount;

//     // Optional: Increment count on click
//     span.addEventListener('click', () => {
//       currentCount += 1;
//       span.querySelector('.viewCount').textContent = currentCount;
//       localStorage.setItem(storageKey, currentCount);
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".faq-item");
  items.forEach(item => {
    const btn = item.querySelector(".faq-question");
    btn.addEventListener("click", () => {
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      } else {
        items.forEach(i => i.classList.remove("active"));
        item.classList.add("active");
      }
    });
  });
});